/**
 * Represents a node in a hierarchical tree structure
 */
export interface TreeNode {
  label: string;
  nodes: TreeNode[];
}

/**
 * Configuration options for TreeNodesParser
 */
export interface TreeNodesParserConfig {
  /**
   * Maximum input size in characters (default: 1MB)
   */
  maxInputSize?: number;
}

/**
 * Parser interface for different input formats
 */
export interface Parser {
  readonly name: string;
  canParse(input: string): boolean;
  parse(input: string): TreeNode[];
}

/**
 * Error types for parser operations
 */
export class ParseError extends Error {
  constructor(
    message: string,
    public readonly parser: string,
    public readonly input?: string
  ) {
    super(message);
    this.name = 'ParseError';
  }
}

/**
 * Error thrown when input exceeds size limits
 */
export class InputSizeError extends Error {
  constructor(
    message: string,
    public readonly actualSize: number,
    public readonly maxSize: number
  ) {
    super(message);
    this.name = 'InputSizeError';
  }
}
